import { VALIDATION_SEVERITIES, VALIDATION_TYPES, Validations } from "@ppb/betslip-core";
import type { BetslipLocalization, CountryCode, Jurisdiction } from "../contract";

type ValidationTerritory = {
  countries: CountryCode[];
  jurisdictions: Jurisdiction[];
};

type ValidationsMap = {
  [k in VALIDATION_TYPES]?: {
    ImplyBets: ValidationTerritory;
    Config: ValidationTerritory;
  };
};

const VALIDATIONS: ValidationsMap = {
  [VALIDATION_TYPES.ABOVE_MAX_PAYOUT]: {
    ImplyBets: {
      countries: [],
      jurisdictions: ["ITALY"],
    },
    Config: {
      countries: ["GB", "IE"],
      jurisdictions: ["BRAZIL"],
    },
  },
};

export const isTerritoryApplicableValidation = (
  validationType: VALIDATION_TYPES,
  { jurisdiction, countryCode }: BetslipLocalization,
): boolean => {
  switch (validationType) {
    case VALIDATION_TYPES.ABOVE_MAX_PAYOUT: {
      return !!(
        VALIDATIONS[validationType]?.ImplyBets.countries.includes(countryCode) ||
        (!!jurisdiction && VALIDATIONS[validationType]?.ImplyBets.jurisdictions.includes(jurisdiction))
      );
    }
    default:
      return true;
  }
};

export const hasSpecialValidation = (
  validationType: VALIDATION_TYPES,
  { jurisdiction, countryCode }: BetslipLocalization,
  hasAboveMaxStakeValidation: boolean,
): boolean => {
  switch (validationType) {
    case VALIDATION_TYPES.ABOVE_MAX_PAYOUT:
      return (
        !hasAboveMaxStakeValidation &&
        !!(
          VALIDATIONS[validationType]?.Config.countries.includes(countryCode) ||
          (!!jurisdiction && VALIDATIONS[validationType]?.Config.jurisdictions.includes(jurisdiction))
        )
      );
    default:
      return false;
  }
};

export const isStakeValid = (
  localization: BetslipLocalization,
  validations?: Validations.CombinationsValidations[],
): boolean => {
  if (!validations) {
    return true;
  }

  return !validations
    .filter((validation) => isTerritoryApplicableValidation(validation.type, localization))
    .filter((validation) =>
      "severity" in validation ? validation.severity === VALIDATION_SEVERITIES.ERROR : !!validation,
    ).length;
};
